import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_AVAILABILITY_PATH } from '../../core/constants';

export const getProductsAvailabilitySingleDayAction = createAsyncThunk(
    'reservation/getProductsAvailabilitySingleDayAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRODUCTS_AVAILABILITY_PATH }/single-day${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductsAvailabilitySingleDaySlice = createSlice({
    name: 'getProductsAvailabilitySingleDaySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getProductsAvailabilitySingleDayAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductsAvailabilitySingleDayAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductsAvailabilitySingleDayAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getProductsAvailabilitySingleDayState = (state) => state.reservation.getProductsAvailabilitySingleDay;
export default getProductsAvailabilitySingleDaySlice.reducer;
